import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';

import { BranchService } from '../../../services/index';

@Component({
	selector: 'add-edit-branch-window',
	templateUrl: './addEditBranch.component.html'
})
export class AddEditBranchComponent implements OnInit {
	public title: string;
	public mode: string;
	public userType: string;
	public list: any[] = [];
	public branchdata: any[] = [];
	ipConfigList: any = ['Yes', 'No'];

	// trigger-variable for Ladda
	isLoading: boolean = false;
	@Output() branchLoadEvent = new EventEmitter();

	constructor(private branchService: BranchService, public snackBar: MdSnackBar, public bsModalRef: BsModalRef, public toasterService: ToasterService) {

	}

	ngOnInit(): void {
		setTimeout(() => {
		    $('#company_name').focus();
		}, 100);
	}
	onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }
	onSaveBranch(): void {
		let that = this;
		this.isLoading = true;
		if(this.branchdata['is_hv_center'] == true) {
			this.branchdata['is_hv_center'] = true
		} else {
			this.branchdata['is_hv_center'] = false
		}
		if(this.branchdata['chk_name']) {
			let chk_name = this.branchdata['chk_name'].toUpperCase();
			this.branchdata['chk_name'] = chk_name;
		}
		this.branchService
			.addUpdateBranch(this.branchdata)
			.then(function(res: any) {
				that.isLoading = false;
				if (res.success){
					swal('SUCCESS', res.message, 'success');
					that.bsModalRef.hide();
					that.branchLoadEvent.emit();
				}else{
					var toast = {
				      type: 'error',
				      title: 'ERROR',
				      body: res.message
				    };
				    that.toasterService.pop(toast);
				}

			});
	}
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/branch/addEditBranch.component.ts